import { render, staticRenderFns } from "./DashboardPurchaseOrderListing.vue?vue&type=template&id=7087c97a&"
import script from "./DashboardPurchaseOrderListing.vue?vue&type=script&lang=js&"
export * from "./DashboardPurchaseOrderListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports